import {FirebaseValueObject, IMMValueObject} from "../../firebase/realtime-database/FirebaseValueObject";
import {EAppReferenceType} from "../cg/core/AppReferenceType";
import {NocoClusterId} from "../../nocodb/model/NocoCluster";

export interface IAppCluster extends IMMValueObject {
  clusterTypeId: NocoClusterId;
  name: string;
  responsibility: 'landlord'|'tenant';
  completed: boolean;
  core: boolean;
  optional: boolean;
}

export class AppCluster extends FirebaseValueObject<IAppCluster>{

  public static readonly TYPE = EAppReferenceType.cluster;

  protected onSetValue(value: IAppCluster | null) {
    super.onSetValue( value );
  }

  constructor( value: IAppCluster ) {
    super(value);

    if( value ) {
      this.value = value;
    }
  }
}
